import { c as _c } from "react/compiler-runtime";
import { isValidElement, type ReactElement } from 'react';
import type { ElementDescriptionDimension, ElementDescriptionMetric } from '../../../internalTypes';
import type { ChartDataRow } from '../../../types';
import { elementDescriptionIsMetric } from '../../../utils/elementDescription';
import { formatMetricValue } from '../../../utils/generics';
import { StyledCellContainer, StyledFooterValue } from '../styled';
import { getColumnDataKey, isFilteredTotal } from '../utils';
import TableFooterDoubleLineCell from './TableFooterDoubleLineCell';
import type { CellAlignment } from '../types';
import type { ChartCardTableFooterContextResolved } from '../tanstack';
import { useChartCardDefaults } from '../../../hooks/useChartCardDefaults';
const TableFooterCellContent = context => {
  const $ = _c(10);
  const defaults = useChartCardDefaults();
  let footerContent;
  let t0;
  let textAlign;
  if ($[0] !== context || $[1] !== defaults) {
    t0 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        meta: contextMeta,
        ...rowContext
      } = context;
      const {
        column
      } = rowContext;
      const dataKey = getColumnDataKey(column);
      const {
        elementsDescriptionsMap,
        total,
        preferTotalsData: t1
      } = contextMeta?.chartCard ?? {};
      const preferTotalsData = t1 === undefined ? false : t1;
      const elementDescription = dataKey == null ? undefined : elementsDescriptionsMap?.[dataKey] as ElementDescriptionMetric | ElementDescriptionDimension | undefined;
      const isMetric = elementDescriptionIsMetric(elementDescription);
      const {
        columnDef: t2
      } = rowContext.column;
      const {
        footer: columnFooter
      } = t2;
      textAlign = isMetric ? "right" : "left";
      if (preferTotalsData && dataKey != null && isMetric) {
        if (typeof total === "number") {
          t0 = <StyledFooterValue textAlign={textAlign}>{formatMetricValue(dataKey, elementDescription, total, defaults.table.format)}</StyledFooterValue>;
          break bb0;
        }
        let t3;
        if ($[5] !== textAlign) {
          t3 = <StyledFooterValue textAlign={textAlign}>{null}</StyledFooterValue>;
          $[5] = textAlign;
          $[6] = t3;
        } else {
          t3 = $[6];
        }
        t0 = t3;
        break bb0;
      }
      footerContent = typeof columnFooter === "function" ? columnFooter(context) : columnFooter;
      if (isValidElement(footerContent)) {
        t0 = <StyledCellContainer>{footerContent}</StyledCellContainer>;
        break bb0;
      }
      if (dataKey != null && isMetric) {
        if (isFilteredTotal(footerContent)) {
          t0 = <TableFooterDoubleLineCell firstLine={formatMetricValue(dataKey, elementDescription, footerContent.filteredTotal, defaults.table.format)} secondLine={formatMetricValue(dataKey, elementDescription, footerContent.total, defaults.table.format)} textAlign={textAlign} />;
          break bb0;
        }
        t0 = <StyledFooterValue textAlign={textAlign}>{formatMetricValue(dataKey, elementDescription, footerContent, defaults.table.format)}</StyledFooterValue>;
        break bb0;
      }
      if (isFilteredTotal(footerContent)) {
        t0 = <TableFooterDoubleLineCell firstLine={formatMetricValue(column.id, {
          type: "number"
        }, footerContent.filteredTotal, defaults.table.format)} secondLine={formatMetricValue(column.id, {
          type: "number"
        }, footerContent.total, defaults.table.format)} textAlign={textAlign} />;
        break bb0;
      }
      if (typeof footerContent === "number") {
        t0 = <StyledFooterValue textAlign={textAlign}>{formatMetricValue(column.id, {
            type: "number"
          }, footerContent, defaults.table.format)}</StyledFooterValue>;
        break bb0;
      }
    }
    $[0] = context;
    $[1] = defaults;
    $[2] = footerContent;
    $[3] = t0;
    $[4] = textAlign;
  } else {
    footerContent = $[2];
    t0 = $[3];
    textAlign = $[4];
  }
  if (t0 !== Symbol.for("react.early_return_sentinel")) {
    return t0;
  }
  const t1 = footerContent ?? "";
  let t2;
  if ($[7] !== t1 || $[8] !== textAlign) {
    t2 = <StyledFooterValue textAlign={textAlign}>{t1}</StyledFooterValue>;
    $[7] = t1;
    $[8] = textAlign;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default TableFooterCellContent;